import { KTIcon } from '@/_metronic/helpers/components/KTIcon'
import { useEffect, useState } from 'react'
import { useFilterReportSalesBudget } from '../../core/FilterReportSalesBudgetProvider'
import { useQueryRequestDaily } from '../../core/QueryRequestDailyProvider'
import { initialFilterDaily } from '../../core/_models'
import moment from 'moment'

const ReportSalesBudgetDailyListToolbar = () => {
  const {handleShowDailyModal} = useFilterReportSalesBudget()
  const {updateFilterReportSalesBudgetFormDailyValue, filterReportSalesBudgetFormDailyValue} =
    useFilterReportSalesBudget()
  const {updateState, state} = useQueryRequestDaily()
  const [filterValue, setFilterValue] = useState(initialFilterDaily)
  const currentDate = new Date()

  const filterData = () => {
    state.set_brand_id = state.brand_id && state.brand_id.length > 0
    state.set_sub_brand_id = state.sub_brand_id && state.sub_brand_id.length > 0
    state.set_region_id = state.region_id && state.region_id.length > 0
    state.set_city_id = state.city_id && state.city_id.length > 0
    state.set_area = state.area && state.area.length > 0
    state.set_outlet_id = state.outlet_id && state.outlet_id.length > 0

    updateState(state)
    updateFilterReportSalesBudgetFormDailyValue({
      ...filterReportSalesBudgetFormDailyValue,
      brand: filterReportSalesBudgetFormDailyValue?.brand?.filter((brand) =>
        Boolean(state?.brand_id?.find((item) => item === brand.value))
      ),
      sub_brand: filterReportSalesBudgetFormDailyValue?.sub_brand?.filter((sub_brand) =>
        Boolean(state?.sub_brand_id?.find((item) => item === sub_brand.value))
      ),
      outlet: filterReportSalesBudgetFormDailyValue?.outlet?.filter((outlet) =>
        Boolean(state?.outlet_id?.find((item) => item === outlet.value))
      ),
      area: filterReportSalesBudgetFormDailyValue?.area?.filter((area) =>
        Boolean(state?.area?.find((item) => item === area.value))
      ),
      region: filterReportSalesBudgetFormDailyValue?.region?.filter((region) =>
        Boolean(state?.region_id?.find((item) => item === region.value))
      ),
      city: filterReportSalesBudgetFormDailyValue?.city?.filter((city) =>
        Boolean(state?.city_id?.find((item) => item === city.value))
      ),
      month: filterReportSalesBudgetFormDailyValue?.month?.filter((month) =>
        Boolean(state?.month?.find((item) => item === month.value))
      ),
    })
  }

  const resetData = () => {
    setFilterValue({
      ...filterValue,
      year: currentDate.getFullYear().toString(),
    })
    updateFilterReportSalesBudgetFormDailyValue(null)
    updateFilterReportSalesBudgetFormDailyValue({
      year: {value: currentDate.getFullYear(), label: currentDate.getFullYear()},
    })
    updateState(initialFilterDaily)
  }

  useEffect(() => {
    let monthList: string[] = []
    if (filterReportSalesBudgetFormDailyValue?.month) {
      filterReportSalesBudgetFormDailyValue.month.forEach((element) => {
        monthList.push(element.value)
      })
    }
    let areaList: string[] = []
    if (filterReportSalesBudgetFormDailyValue?.area) {
      filterReportSalesBudgetFormDailyValue.area.forEach((element) => {
        areaList.push(element.value)
      })
    }
    let outletList: string[] = []
    if (filterReportSalesBudgetFormDailyValue?.outlet) {
      filterReportSalesBudgetFormDailyValue.outlet.forEach((element) => {
        outletList.push(element.value)
      })
    }
    let brandList: string[] = []
    if (filterReportSalesBudgetFormDailyValue?.brand) {
      filterReportSalesBudgetFormDailyValue.brand.forEach((element) => {
        brandList.push(element.value)
      })
    }
    let subBrandList: string[] = []
    if (filterReportSalesBudgetFormDailyValue?.sub_brand) {
      filterReportSalesBudgetFormDailyValue.sub_brand.forEach((element) => {
        subBrandList.push(element.value)
      })
    }
    let regionList: string[] = []
    if (filterReportSalesBudgetFormDailyValue?.region) {
      filterReportSalesBudgetFormDailyValue.region.forEach((element) => {
        regionList.push(element.value)
      })
    }
    let cityList: string[] = []
    if (filterReportSalesBudgetFormDailyValue?.city) {
      filterReportSalesBudgetFormDailyValue.city.forEach((element) => {
        cityList.push(element.value)
      })
    }

    setFilterValue({
      ...filterValue,
      set_area: Boolean(filterReportSalesBudgetFormDailyValue?.area),
      area: areaList,
      set_outlet_id: Boolean(filterReportSalesBudgetFormDailyValue?.outlet),
      outlet_id: outletList,
      set_brand_id: Boolean(filterReportSalesBudgetFormDailyValue?.brand),
      brand_id: brandList,
      set_sub_brand_id: Boolean(filterReportSalesBudgetFormDailyValue?.sub_brand),
      sub_brand_id: subBrandList,
      set_region_id: Boolean(filterReportSalesBudgetFormDailyValue?.region),
      region_id: regionList,
      set_city_id: Boolean(filterReportSalesBudgetFormDailyValue?.city),
      city_id: cityList,
      month: monthList,
      year: filterReportSalesBudgetFormDailyValue?.year
        ? filterReportSalesBudgetFormDailyValue?.year?.value?.toString()
        : currentDate.getFullYear().toString(),
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterReportSalesBudgetFormDailyValue])

  return (
    <div className='d-flex justify-content-end py-3 me-8'>
      <div className='d-flex'>
        <div>
          {state?.brand_id?.map((brand_id, index) => {
            return (
              <span className='badge badge-pill badge-light mx-3 my-2'>
                Brand :{' '}
                {
                  filterReportSalesBudgetFormDailyValue?.brand?.find((item) => item.value === brand_id)
                    ?.label
                }
                <div
                  className='cursor-pointer'
                  onClick={() => {
                    const updatedItems = state?.brand_id
                      ?.slice(0, index)
                      .concat(state?.brand_id.slice(index + 1))
                    state.brand_id = updatedItems
                    state.set_brand_id = (updatedItems ?? []).length > 0
                    setFilterValue({
                      ...filterValue,
                      brand_id: state.brand_id,
                      set_brand_id: state.set_brand_id,
                    })
                    filterData()
                  }}
                >
                  <span className='ki-solid ki-cross fs-2x' />
                </div>
              </span>
            )
          })}
          {state?.sub_brand_id?.map((sub_brand, index) => {
            return (
              <span className='badge badge-pill badge-light mx-3 my-2'>
                Sub Brand :{' '}
                {
                  filterReportSalesBudgetFormDailyValue?.sub_brand?.find(
                    (item) => item.value === sub_brand
                  )?.label
                }
                <div
                  className='cursor-pointer'
                  onClick={() => {
                    const updatedItems = state?.sub_brand_id
                      ?.slice(0, index)
                      .concat(state?.sub_brand_id.slice(index + 1))
                    state.sub_brand_id = updatedItems
                    state.set_sub_brand_id = (updatedItems ?? []).length > 0
                    setFilterValue({
                      ...filterValue,
                      sub_brand_id: state.sub_brand_id,
                      set_sub_brand_id: state.set_sub_brand_id,
                    })
                    filterData()
                  }}
                >
                  <span className='ki-solid ki-cross fs-2x' />
                </div>
              </span>
            )
          })}
          {state?.area?.map((area, index) => {
            return (
              <span className='badge badge-pill badge-light mx-3 my-2'>
                Area :{' '}
                {filterReportSalesBudgetFormDailyValue?.area?.find((item) => item.value === area)?.label}
                <div
                  className='cursor-pointer'
                  onClick={() => {
                    const updatedItems = state?.area
                      ?.slice(0, index)
                      .concat(state?.area.slice(index + 1))
                    state.area = updatedItems
                    state.set_area = (updatedItems ?? []).length > 0
                    setFilterValue({...filterValue, area: state.area, set_area: state.set_area})
                    filterData()
                  }}
                >
                  <span className='ki-solid ki-cross fs-2x' />
                </div>
              </span>
            )
          })}
          {state?.region_id?.map((region, index) => {
            return (
              <span className='badge badge-pill badge-light mx-3 my-2'>
                Region :{' '}
                {
                  filterReportSalesBudgetFormDailyValue?.region?.find((item) => item.value === region)
                    ?.label
                }
                <div
                  className='cursor-pointer'
                  onClick={() => {
                    const updatedItems = state?.region_id
                      ?.slice(0, index)
                      .concat(state?.region_id.slice(index + 1))
                    state.region_id = updatedItems
                    state.set_region_id = (updatedItems ?? []).length > 0
                    setFilterValue({
                      ...filterValue,
                      region_id: state.region_id,
                      set_region_id: state.set_region_id,
                    })
                    filterData()
                  }}
                >
                  <span className='ki-solid ki-cross fs-2x' />
                </div>
              </span>
            )
          })}
          {state?.city_id?.map((city, index) => {
            return (
              <span className='badge badge-pill badge-light mx-3 my-2'>
                City :{' '}
                {filterReportSalesBudgetFormDailyValue?.city?.find((item) => item.value === city)?.label}
                <div
                  className='cursor-pointer'
                  onClick={() => {
                    const updatedItems = state?.city_id
                      ?.slice(0, index)
                      .concat(state?.city_id.slice(index + 1))
                    state.city_id = updatedItems
                    state.set_city_id = (updatedItems ?? []).length > 0
                    setFilterValue({
                      ...filterValue,
                      city_id: state.city_id,
                      set_city_id: state.set_city_id,
                    })
                    filterData()
                  }}
                >
                  <span className='ki-solid ki-cross fs-2x' />
                </div>
              </span>
            )
          })}
          {state?.outlet_id?.map((outlet, index) => {
            return (
              <span className='badge badge-pill badge-light mx-3 my-2'>
                Outlet :{' '}
                {
                  filterReportSalesBudgetFormDailyValue?.outlet?.find((item) => item.value === outlet)
                    ?.label
                }
                <div
                  className='cursor-pointer'
                  onClick={() => {
                    const updatedItems = state?.outlet_id
                      ?.slice(0, index)
                      .concat(state?.outlet_id.slice(index + 1))
                    state.outlet_id = updatedItems
                    state.set_outlet_id = (updatedItems ?? []).length > 0
                    setFilterValue({
                      ...filterValue,
                      outlet_id: state.outlet_id,
                      set_outlet_id: state.set_outlet_id,
                    })
                    filterData()
                  }}
                >
                  <span className='ki-solid ki-cross fs-2x' />
                </div>
              </span>
            )
          })}
          {state?.start_date && (
            <span className='badge badge-pill badge-light mx-3 my-2 py-4'>
              Date : {moment(state.start_date).format('DD MMMM yyyy')} -{' '}
              {moment(state.end_date).format('DD MMMM yyyy')}
            </span>
          )}
        </div>
        {((state.brand_id! ?? []).length > 0 ||
          (state.sub_brand_id! ?? []).length > 0 ||
          (state.area! ?? []).length > 0 ||
          (state.region_id! ?? []).length > 0 ||
          (state.city_id! ?? []).length > 0 ||
          (state.outlet_id! ?? []).length > 0) && (
          <div
            className='col-auto me-5 d-flex align-items-center h6 text-muted cursor-pointer'
            onClick={() => resetData()}
          >
            <u>Clear All</u>
          </div>
        )}
        <div className='col-auto d-flex align-items-center'>
          <button
            type='button'
            className='btn btn-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            onClick={() => handleShowDailyModal()}
          >
            <KTIcon iconName='filter' className='fs-2' />
            Filter
          </button>
        </div>
      </div>
    </div>
  )
}

export { ReportSalesBudgetDailyListToolbar }

